import { Cart, MyCartUpdate } from "@commercetools/platform-sdk";
import { CustomerIntent, OrderIntent } from "@wttb/shared";
import { Session } from "next-auth";

import { createApiClient } from "@/clients/commercetools";

export const updateCartCustomerFields = async (cart: Cart, session: Session) => {
  const api = createApiClient(session.accessToken).me();
  let customer;
  if (!session?.isAnonymous) {
    customer = await api
      .get()
      .execute()
      .then(({ body }) => body);
  }
  const cartApi = api.carts();

  const body = {
    version: cart.version,
    actions: [
      {
        action: "setCustomField",
        name: "vip",
        value: customer?.custom?.fields.vip ?? false,
      },
      {
        action: "setCustomField",
        name: "intent",
        value:
          customer?.custom?.fields?.intent === CustomerIntent.Test
            ? OrderIntent.Test
            : OrderIntent.Standard,
      },
      {
        action: "setCustomerEmail",
        email: customer?.email,
      },
    ],
  } as MyCartUpdate;

  if (customer?.custom?.fields?.loyaltyTierKey) {
    // it's not required, but can't be removed if not present
    body.actions.push({
      action: "setCustomField",
      name: "loyaltyTierKey",
      value: customer.custom.fields.loyaltyTierKey,
    });
  } else if (cart.custom?.fields?.loyaltyTierKey) {
    // if it's present, and we want to remove it - it's acceptable.
    body.actions.push({
      action: "setCustomField",
      name: "loyaltyTierKey",
      value: customer?.custom?.fields.loyaltyTierKey,
    });
  }

  return await cartApi.withId({ ID: cart.id }).post({ body }).execute();
};
